/** 询比价单状态 value string类型，tab组件使用 */
//     WaitOffer(0, '等待报价'),
//     Offered(1, '已报价'),
//     AbandonOffer(2, '弃报价'),
//     WaitConfirmNewPrice(3, '议价待确认'),
//     WaitAccept(4, '待采纳'),
//     AcceptFinish(5, '采纳结束');

export const stateList = [
    { label: '全部', value: '-1' },
    { label: '待报价', value: '0' },
    { label: '已报价', value: '1' },
    { label: '弃报价', value: '2' },
    { label: '议价待确认', value: '3' },
    { label: '待采纳', value: '4' },
    { label: '采纳结束', value: '5' },
];

export const canEditStates = [0, 1];

/** 询比价sku明细状态 value string类型，tab组件使用 */
export const skuDetailState = [
    { label: '全部', value: '-1' },
    { label: '有报价记录商品', value: '1' },
    { label: '无报价记录商品', value: '0' },
    { label: '已采纳商品', value: '2' }
];

export const enquiryTypeList = [
    { label: '全部', value: -1 },
    { label: '部分询价', value: 1 },
    { label: '整单打包询价', value: 0 },
    { label: 'C3询价单', value: 2 }
];
